import React, { useState, useEffect } from "react";
import { Link,useNavigate,useLocation,useParams } from "react-router-dom";
import {
  Form,Input,message,Button,Modal,Spin,
} from "antd";
import qhrset from "../../assets/landingFeatures/qhrset.png";
import { actionsCandidates } from "../../actions";
import "./otpprocess.css";
import { useDispatch } from "react-redux";
import useMembersStore from "../../store/members.store";
import { LoadingOutlined } from "@ant-design/icons";

export default function OTPProcessCandidates() {
    const [loader, SetLoader] = useState(false);
    const [formKey1, setFormKey1] = useState(1);
    const [nextState, setNextState] = useState(0)
    const [currentReason, setReason] = useState("start")
    const [sessionID, setSessionID] = useState("")
    const [timer, setTimer] = useState();
    const [isResendDisabled, setIsResendDisabled] = useState(false);
    const [resendOTPLoader, setResendOTPLoader] = useState(false);
    const navigate = useNavigate();
    const { name, qhoid,jdID, resumeID } = useParams();

    const dispatch = useDispatch();
    const[error,setError] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { setSubscription } = useMembersStore();
    const [messageApi, contextHolder] = message.useMessage();

    let location = useLocation();
    const { reasonCheck, trigger,signupemail } = location.state || {};
    var reason = "start"
    var localTrigger = "signin";

    const [inputData, setFormData] = useState({
      otp:"",
      username: "",
      contact: "",
      email: "",
      companyname:name,
      ownerid:qhoid,
      jdid:jdID,
      qhrid: resumeID
    });

    useEffect(() => {
        setFormData({
        otp:"",
        username: "",
        contact: "",
        email: "",
        companyname:name,
        ownerid:qhoid,
        jdid:jdID,
        qhrid: resumeID
      })
      //console.log("location", location.state);
    }, []);

  useEffect(() => {
    let interval;
    if (isResendDisabled && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1);
      }, 1000);
    } else {
      setIsResendDisabled(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer, isResendDisabled]);

  const successOTP = () => {
    messageApi.open({
      type: "success",
      content: "OTP sent successfully",
    });
  };

  const errorOTP = () => {
    messageApi.open({
      type: "error",
      content: "OTP sent failed",
    });
  };

  const handleFormSubmit = (values) => {};
    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const handleOk = () => {
      setIsModalOpen(false);
    };
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    //as per the api interface
    const getJsonDataSignIn = (inputData) => {
      return {
        mobile: inputData.contact,
        emailid: inputData.email,
        companyname:name,
        qhoid:qhoid,
        qhcompanyjid:jdID,
        qhrid: resumeID
      }
    };

    //as per the api interface
    const getJsonDataOTPVerify = (inputData) => {
      return {
        sessionid:sessionID,
        mobile: inputData.contact,
        emailid: inputData.email,
        companyname:name,
        qhoid:qhoid,
        qhcompanyjid:jdID,
        qhrid: resumeID,
        otp:inputData.otp
      }
    };    
    const dispatchSignIn = (values) =>{
      SetLoader(true);
      var req = getJsonDataSignIn(inputData)

      dispatch(actionsCandidates.CanSignIn(req, (error, status,session) => {
        if (!error) {
          setReason("verifyotp")
          setSessionID(session)
          //console.log("Settting my session",session)
          setIsResendDisabled(true);
          setTimer(5);
          SetLoader(false);       
          successOTP();
        } else {
          // Handle the error case
          SetLoader(false);
          console.error("API Error:", error);
         
          if( error == "decode error"){
            setError("Kindly fill right details." ); // Set the error message in state
          }else if( error == "please sign in"){
            setError("Account already created, kindly sign in."); // Set the error message in state
          }else if( error == "verification pending"){
            setError("OTP Verification pending, Kindly verify your email id."); // Set the error message in state
          }else {
            setError(error)
          }
          showModal()
          //console.log("status", status);
        }
      }));

      if (nextState) {
        localTrigger = "signin"
        setReason("verifyotp")
        setNextState(1)
      }
       
    }
    const dispatchAlreadygotOtp = (values) =>{

        SetLoader(true);
        dispatch(actionsCandidates.CanVerifySigninOtp(inputData, (error, status) => {
          if (!error) {
            navigate("/otp", { state: { inputData, type: "signup" } });
            SetLoader(false);
          } else {
            // Handle the error case
            SetLoader(false);
            console.error("API Error:", error);
           
            if( error == "decode error"){
              setError("Kindly fill right details." ); // Set the error message in state
            }else if( error == "please sign in"){
              setError("Account already created, kindly sign in."); // Set the error message in state
            }else if( error == "verification pending"){
              setError("OTP Verification pending, Kindly verify your email id."); // Set the error message in state
            }else {
              setError(error)
            }
            showModal()
            //console.log("status", status);
          }
        }));        
    }
    const dispatchResendOtp = (values) =>{

    setResendOTPLoader(true);
    //console.log("inputData: ", inputData);
    // setResendOTPLoader(true);
    dispatch(
      actionsCandidates.CanResendOTP({ email: inputData.email }, (error, status) => {
        if (!error) {
          navigate("/otpprocess", {
            state: {
              reason: "verifyotp",
              trigger: localTrigger,
              value: "resend",
            },
          });
          setReason("verifyotp")

          SetLoader(false);
          setResendOTPLoader(false);
          setIsResendDisabled(true);
          setTimer(5);
          successOTP();
          } else {
            // Handle the error case
            SetLoader(false);
            console.error("API Error:", error);
           
            if( error == "decode error"){
              setError("Kindly fill right details." ); // Set the error message in state
            }else if( error == "please sign in"){
              setError("Account already created, kindly sign in."); // Set the error message in state
            }else if( error == "verification pending"){
              setError("OTP Verification pending, Kindly verify your email id."); // Set the error message in state
            }else {
              setError(error)
            }
          // showModal();
          // fail();
           // console.log("status", status);
          }
        }));        
    }
    const dispatchVerifyOtp = (values) =>{
        SetLoader(true);
        var req = getJsonDataOTPVerify(inputData)
        dispatch(actionsCandidates.CanVerifySigninOtp(req, (error, status) => {
          if (!error) {
            navigate("/qsethome/qsetdashboard")
            SetLoader(false);
          } else {
            // Handle the error case
            SetLoader(false);
            console.error("API Error:", error,status);
           
            if( error == "decode error"){
              setError("Kindly fill right details." ); // Set the error message in state
            }else if( error == "please sign in"){
              setError("Account already created, kindly sign in."); // Set the error message in state
            }else if( error == "verification pending"){
              setError("OTP Verification pending, Kindly verify your email id."); // Set the error message in state
          } else if (error == "Incorrect OTP") {
            setError("Incorrect OTP, Please Enter Correct OTP");
          } // Set the error message in state
          else {
            setError(error);
          }
          showModal();
          //console.log("status", status);
        }
      })
    );
  };

  const handleOtpProcess = (values) => {
    //console.log("formData", inputData);
    // SetLoader(true);

    if (localTrigger == "signin" && currentReason == "start") {
      dispatchSignIn();
    }
    if (localTrigger == "signin" && currentReason == "verifyotp") {
      dispatchVerifyOtp();
    }
    if (currentReason == "resend") {
      dispatchResendOtp();
    }
    if (currentReason == "alreadygot") {
      dispatchAlreadygotOtp();
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name,value)
    setFormData({ ...inputData, [name]: value });
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins < 10 ? `0${mins}` : mins}:${secs < 10 ? `0${secs}` : secs}`;
  };
    return (
     <div className="otpprocess-candidate-wrapper">
      {contextHolder}
        <div className="otpprocess-form-wrapper">
          <div className="signupnew-leftarea">
              <h2>
                {name.replace('+', ' ')}
              </h2>     
             Skill Evaluation Test Platform     
          </div>

          <div className="signupnew-rightarea"> 
          <div className="signupnew-heading">
               {localTrigger == "signin"?
                currentReason == "start" ? <>Sign In</>:<>Continue Sign In </>
                :<><br></br></>}
          </div> 
            <Form
              key={formKey1}
              className="profile-form"
              name="signon-form"
              justify="start"
              layout="vertical"
              autoComplete="off"
              onFinish={handleFormSubmit}
             >                    
             {
                currentReason != "verifyotp"?
                <>
                    <Form.Item
                                required = {true}                            
                                className="profile-field-item"
                                label="Email ID"
                                name="email"
                            >
                                <Input
                                    required = {true}
                                    className="profile-input-full"
                                    onChange={handleChange}
                                    name="email"
                                />
                    </Form.Item>   
                    <Form.Item
                            required = {true}
                            className="profile-field-item"
                            label="Mobile Number"
                            name="contact"
                        >
                            <Input
                            required = {true}
                            className="profile-input-full"
                            onChange={handleChange}
                            name="contact"
                            />
                    </Form.Item>                                 
                </>:
                <></>
             }

             {
                currentReason == "alreadygot" || currentReason == "verifyotp"
                ?<>
                   <Form.Item
                      required = {true}
                      className="profile-field-item"
                      label="OTP"
                      name="validotp"
                  >
                      <Input
                          required = {true}
                          className="profile-input-full"
                          onChange={handleChange}
                          name="otp"
                      />
                  </Form.Item>               
                </>
                :<> </>
             } 

                <Button
                    style={{ width: "100%", height: "40px", fontWeight: "600" }}
                    type="primary"
                    htmlType="submit"
                    onClick={handleOtpProcess}
                >
                    {loader ? (
                      <Spin
                        indicator={
                          <LoadingOutlined style={{ color: "white" }} spin />
                        }
                      />
                    ) : currentReason == "start" ? (
                      <>Sign In</>
                    ) : currentReason == "verifyemail" ? (
                      <>Verify Email ID</>
                    ) : currentReason == "verifyotp" ? (
                      <>Verify OTP</>
                    ) : currentReason == "alreadygot" ? (
                      <>Verify OTP</>
                    ) : (
                      <>Resend OTP</>
                    )}
                </Button>           
            </Form>  
            {
              <Modal title={trigger=="signin"?"Sign In":"Sign Up"} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                 {error}
              </Modal>
            }
            <div className="signupnew-links-wrapper">
            {localTrigger == "signin" && currentReason == "verifyotp" ? (
              <div className="signupnew-links">
                {!resendOTPLoader ? (
                  <p
                    onClick={(e) => {
                      if (isResendDisabled) {
                        e.preventDefault();
                      } else {
                        dispatchResendOtp();
                      }
                    }}
                    style={{
                      pointerEvents: isResendDisabled ? "none" : "auto",
                      color: isResendDisabled ? "gray" : "blue",
                      cursor: isResendDisabled ? "not-allowed" : "pointer",
                      textDecorationLine: "underline",
                    }}
                  >
                    Resend OTP{" "}
                    {isResendDisabled ? "In " + formatTime(timer) : ""}
                  </p>
                ) : (
                  <>
                    <p>
                      Please Wait
                      <Spin
                        style={{ marginLeft: "10px" }}
                        indicator={<LoadingOutlined spin />}
                        size="small"
                      />
                    </p>
                  </>
                )}
              </div>
            ) : (
              <></>
            )}
               
          </div>

            <div className="signupnew-links-wrapper">             
              <div className="signupnew-links">
                <Link
                  state= {{ reason: "start" ,trigger: "signin"}} 
                  onClick={()=>{setReason("start")}}
                > 
                  Sign In
                </Link>
              </div> 
              <div className="signupnew-links">
                <Link
                  to={"/otpprocess"}
                state={{ reason: "alreadygot", trigger: localTrigger }}
                > 
                Got Valid OTP?
                </Link>
              </div>              
            </div>         
          </div>
        </div>

        <div className="otpprocess-candiddate-footer">
                  <img
                    src={qhrset}
                    alt="Explorer"
                    width="100" height="100" 
                  /> 
        <div>
          <p>Powered by QHRSET.</p>
        </div>
        <div>
          <a>
            <p>
              An QUALLYHire AI Product Family from HMW Communications Pvt. Ltd
            </p>
          </a>
        </div>
        </div>
     </div>

    );
}
